// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salary-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}
.error-message-for-uploadfile {
  white-space: pre-wrap;
  max-height: 150px;
  overflow-y: auto;
  color: red;
  font-size: 14px;
}
.upload-box-payslip {
  width: 250px;  /* Set width */
  height: 50px;  /* Set height */
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 10px;
  cursor: pointer;
  margin-right:630px;
  margin-top:20px;
}


.file-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}

.upload-text {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.upload-title {
  font-weight: bold;
  font-size: 14px;
}

.file-name {
  font-size: 12px;
  color: #777;
  margin-top: 4px;
}

.upload-icon {
  width: 30px;
  height: 30px;
  margin-right: 20px;  /* Ensures proper spacing */
}

.error-message {
  color: red;
  font-size: 14px;
  font-weight: bold;
}
/* Table wrapper to ensure scrollbar starts from the first column */
.salary-table-container {
  width: 100%; 
  max-width: 900px;
  max-height: 500px;
  border: 1px solid #ddd;
  padding: 10px;
  background: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden; /* Prevents double scrollbars */
  margin-top:-50px;
}

.admin-table-container{
  width: 100%; 
  max-width: 900px;
  max-height: 500px;
  border: 1px solid #ddd;
  padding: 10px;
  background: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 0 auto; 
  overflow-y: auto; /* Prevents double scrollbars */
  margin-top:-30px;
}

/* New wrapper to manage scrolling */
.table-scroll-wrapper {
  width: 100%;
}

/* Table styling */
.salary-table {
  width: max-content; /* Ensures table expands based on content */
  border-collapse: collapse;
  min-width: 800px; 
  table-layout: auto;

  border-collapse: collapse; /* FIX: Prevents overlap issues */
  border-spacing: 0; /* Ensures no gaps */
}
.salary-table-wrapper {
  max-height: 400px;  /* or any height you prefer */
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #ccc;
}

/* Header and cell styling */
.salary-table th {
  min-width: 120px; /* Ensure each column is at least 120px wide */
  text-align: left;
  height:40px;
  font-weight: bold;
  background-color: #c0bebe;
  border-color:#f8f9fa
  
}
.salary-table thead {
  position: sticky;
  top: 0;
  padding: 10px;

  background-color: #f8f9fa; /* Light background for visibility */
  z-index: 2;
}
.salary-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
  white-space: nowrap; /* Prevent text wrapping */
}
.salary-table tfoot {
  position: sticky;
  bottom: 0;
  background: #ddd; /* Light grey background for footer */
  font-weight: bold;
  z-index: 2;
}
/* Sticky Header (top row) */
.salary-table thead th {
  position: sticky;
  top: 0;
  background: #c0bebe;
  z-index: 10; /* High enough to stay above content */
}


.salary-table tfoot {
  position: sticky;
  bottom: 0;
  background-color: #fff; /* Match table background */
  z-index: 2;
}
.invalid-cell {
  background-color: #ffcccc !important;  /* Light red */
  border: 1px solid #ff0000;
}

.updated-cell {
  background-color: #ccffcc !important;  /* Light green */
  border: 1px solid #00cc00;
}

.sticky-footer {
  font-weight: bold;
  text-align: right;
  padding: 10px;
  background-color: #f1f1f1; /* Light gray background */
  border-top: 2px solid #ddd;
}


/* Alternate row colors */
.salary-table tbody tr:nth-child(even) {
  background: white;
}


/* Sticky first column only */


/* ✅ Row Hover Effect for Full Row */
.salary-table tbody tr:hover {
  background-color: #e4ebf1d0;
}

/* ✅ Ensure Sticky Columns Also Change on Hover */
.salary-table tbody tr:hover td:first-child,
.salary-table tbody tr:hover td:nth-child(2) {
  background-color: #e4ebf1d0; /* Same color as row hover */
}


/* Alternate Row Colors */
/* .salary-table tbody tr:nth-child(even) {
  background-color: #f2f2f2; */
/* Ensure table adjusts to content */
.salary-table th {
  text-align: left;
  font-weight: bold;
  
}

.salary-table th:nth-child(1),
.salary-table th:nth-child(2) {
  background: #c0bebe; /* Ensure consistency with header background */
  border-right: 2px solid #ddd; /* Light blue border */
}






/* Upload Button */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  left: 0; /* Ensures it sticks while scrolling horizontally */
margin-left:15px;
  position: sticky;

}

.table-heading {
  margin: 0;
}

.salary-search-box {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  width: 200px; /* Adjust width as needed */
  transition: all 0.3s ease-in-out;
}

.salary-search-box:focus {
  border-color: #007bff; /* Blue border on focus */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
}







.upload-btn {
  padding: 8px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.upload-btn:hover {
  background-color: #0056b3;
}


.upload-btn:hover {
  background-color: #0056b3;
}


/* Highlight updated rows */
.updated-row {
  background-color: #ffeb3b !important; /* Yellow highlight */
  font-weight: bold;
  transition: background 0.5s ease-in-out;
}



/* Search Input */

/* .salary-table th {
  background-color: #4CAF50;
  color: white;
  padding: 8px;
  text-align: left;
} */
/* Upload Button */
.upload-btn {
  padding: 8px 12px;
  font-size: 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

.upload-btn:hover {
  background-color: #0056b3;
}

.updated-row {
  background-color: #ffeb3b !important; /* Yellow highlight */
  transition: background-color 0.5s ease;
}
.updated-cell {
  background-color: #ffeb3b !important; /* Yellow highlight */
  font-weight: bold;
  transition: background-color 0.5s ease;
}


.no-updates-message {
  color: green;
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
}



.error-message {
  color: red;
  font-weight: bold;
  margin-top: 10px;
}

.invalid-cell {
  background-color: #ffcccc !important;
  color: red;
  font-weight: bold;
}


.salary-month-year-selector-box{
  width: 250px;  /* Set width */
  height: 50px;  /* Set height */
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 10px;
  cursor: pointer;
  margin-left:320px;
  margin-top:-75px;
}

.salary-month-year-selector {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top:-7%;
}

.salary-month-year-dropdown {
  padding: 4px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  width: 220px;
}



.error-message-for-uploadfile{
  
  color: red;
  font-weight: bold;
  margin: 5px ;
  min-height: 20px; /* Ensures space is reserved for the error message */
}
.error-cell {
  background-color: #ffcccc !important; /* Light red background */
  border: 2px solid red !important;
  color: red !important;
  font-weight: bold;
}
.error-cell {
  background-color: #ffcccc; /* Light red background for errors */
  border: 2px solid red;
}

.updated-cell {
  background-color: #ccffcc; /* Light green for updated cells */
}
/* Scrollable container */
/* Scrollable container */
.adminsalary-table-container {
  width: 100% !important;
  max-width: 1400px; /* Limit table width */
  padding: 8px;
  max-height: 200px; /* Adjust height for scrolling */
  position: relative; /* Ensure correct positioning of sticky header */
}

/* Table Styling */
.adminsalary-table {
  width: 100%;
  min-width: 600px; /* Ensure table does not shrink too much */
  border-collapse: collapse;
  text-align: left;
}

/* Table Header */
.adminsalary-table th {
  padding: 8px;
  background: #c0bebe;
  white-space: nowrap; /* Prevent header text from wrapping */
  border: 1px solid #ddd;
  z-index: 3;
  height: 30px;
  position: sticky;
  top: 0;  /* Make header stick at the top of the container */
  background-color: #c0bebe;
}

/* Table Data Cells */
.adminsalary-table td {
  padding: 8px;
  white-space: nowrap; /* Prevent wrapping */
  border: 1px solid #ddd;
}


/* Alternate Row Styling */
.adminsalary-table tbody tr:nth-child(even) {
  background: #f9f9f9;
}

/* Hover Effect */
.adminsalary-table tbody tr:hover {
  background: #f1f1f1;
}


.adminsalary-table tbody tr:hover {
  background: #e0e0e0 !important;
}

/* Sticky Footer */
.adminsalary-table tfoot {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  z-index: 2;
  text-align: right; /* Align the total amount to the right */
  padding: 8px;
  font-weight: bold;
}

.adminsalary-sticky-footer {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  text-align: right;
  font-weight: bold;
  padding: 10px;
  border-top: 2px solid #ccc;
  z-index: 1;
}

.footer-cell {
  display: inline-block;
  padding-right: 20px;
}


.net-salary-row {
  position: sticky;
  bottom: 0;
  background-color: #f1f1f1;
  font-weight: bold;
  z-index: 2;
  height: 30px;
  text-align: left;
}

/* Ensure footer content has a similar background as header */


/* Make footer sticky and always visible */
.adminsalary-sticky-footer {
  position: sticky;
  bottom: 0;
  width: 100%;
  background-color: #c0bebe;
  color: black;
  padding: 10px 16px;
  font-weight: bold;
  text-align: right;
  border-top: 2px solid #ccc;
  z-index: 10; /* higher than sticky first/second columns */
  display: flex;
  justify-content: flex-end;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow */
}

.footer-cell {
  flex: 1 1;
}


.reference-container {
  display: flex;
  justify-content: center; /* Centers the elements */
  align-items: center;
  flex-wrap: wrap; /* Prevents overlap on smaller screens */
  gap: 20px; /* Adds spacing between elements */
  width: 100%;
  margin-top: 20px;
}
.reference-box {
  width: 250px;  /* Set width */
  height: 50px;  /* Set height */
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 10px;
  cursor: pointer;
  margin-left:630px;
  margin-top:-210px;
  position: relative;
  z-index: 1;
}

.reference-text {
  font-size: 14px;
  color: #131010;
  margin-bottom: 8px;
}

.download-template-btn {
  background-color: #007bff;
  color: white;
  padding: 8px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
}

.download-template-btn:hover {
  background-color: #0056b3;
}

.adminsalary-table-header {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  padding: 10px;
  color: black;
}
.admin-search-box {
  width: 100px; /* Adjust the width */
  padding: 6px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-left: -45%;
  outline: none;
}
.admin-search-box::placeholder {
  color: #888;
  font-size: 12px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-container {
    max-height: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Salary_statement/Salary_Statement.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY,GAAG,cAAc;EAC7B,YAAY,GAAG,eAAe;EAC9B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,GAAG,2BAA2B;AAClD;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA,mEAAmE;AACnE;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB,EAAE,+BAA+B;EACjD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,gBAAgB,EAAE,+BAA+B;EACjD,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,kBAAkB,EAAE,2CAA2C;EAC/D,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;;EAElB,yBAAyB,EAAE,iCAAiC;EAC5D,iBAAiB,EAAE,oBAAoB;AACzC;AACA;EACE,iBAAiB,GAAG,6BAA6B;EACjD,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB,EAAE,8CAA8C;EAChE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB;;AAEF;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;;EAEb,yBAAyB,EAAE,oCAAoC;EAC/D,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,mBAAmB,EAAE,0BAA0B;AACjD;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB,EAAE,qCAAqC;EACvD,iBAAiB;EACjB,UAAU;AACZ;AACA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,WAAW,EAAE,sCAAsC;AACrD;;;AAGA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB,EAAE,2BAA2B;EACnD,UAAU;AACZ;AACA;EACE,oCAAoC,GAAG,cAAc;EACrD,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC,GAAG,gBAAgB;EACvD,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,yBAAyB,EAAE,0BAA0B;EACrD,0BAA0B;AAC5B;;;AAGA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;;;AAGA,6BAA6B;;;AAG7B,oCAAoC;AACpC;EACE,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD;;EAEE,2BAA2B,EAAE,4BAA4B;AAC3D;;;AAGA,yBAAyB;AACzB;8BAC8B;AAC9B,oCAAoC;AACpC;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;;EAEE,mBAAmB,EAAE,8CAA8C;EACnE,4BAA4B,EAAE,sBAAsB;AACtD;;;;;;;AAOA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,OAAO,EAAE,mDAAmD;AAC9D,gBAAgB;EACd,gBAAgB;;AAElB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY,EAAE,2BAA2B;EACzC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB,EAAE,yBAAyB;EAChD,0CAA0C;AAC5C;;;;;;;;AAQA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;AAC3B;;;AAGA,2BAA2B;AAC3B;EACE,oCAAoC,EAAE,qBAAqB;EAC3D,iBAAiB;EACjB,uCAAuC;AACzC;;;;AAIA,iBAAiB;;AAEjB;;;;;GAKG;AACH,kBAAkB;AAClB;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;EAC3D,sCAAsC;AACxC;AACA;EACE,oCAAoC,EAAE,qBAAqB;EAC3D,iBAAiB;EACjB,sCAAsC;AACxC;;;AAGA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;;;AAIA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,UAAU;EACV,iBAAiB;AACnB;;;AAGA;EACE,YAAY,GAAG,cAAc;EAC7B,YAAY,GAAG,eAAe;EAC9B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;;;AAIA;;EAEE,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,gBAAgB,EAAE,oDAAoD;AACxE;AACA;EACE,oCAAoC,EAAE,yBAAyB;EAC/D,gCAAgC;EAChC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;AACA,yBAAyB;AACzB,yBAAyB;AACzB;EACE,sBAAsB;EACtB,iBAAiB,EAAE,sBAAsB;EACzC,YAAY;EACZ,iBAAiB,EAAE,gCAAgC;EACnD,kBAAkB,EAAE,gDAAgD;AACtE;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,gBAAgB,EAAE,0CAA0C;EAC5D,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB,EAAE,sCAAsC;EAC3D,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,MAAM,GAAG,kDAAkD;EAC3D,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,mBAAmB,EAAE,qBAAqB;EAC1C,sBAAsB;AACxB;;;AAGA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;;AAGA;EACE,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV,iBAAiB,EAAE,wCAAwC;EAC3D,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA,6DAA6D;;;AAG7D,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW,EAAE,4CAA4C;EACzD,aAAa;EACb,yBAAyB;EACzB,yCAAyC,EAAE,oBAAoB;AACjE;;AAEA;EACE,SAAO;AACT;;;AAGA;EACE,aAAa;EACb,uBAAuB,EAAE,yBAAyB;EAClD,mBAAmB;EACnB,eAAe,EAAE,wCAAwC;EACzD,SAAS,EAAE,kCAAkC;EAC7C,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY,GAAG,cAAc;EAC7B,YAAY,GAAG,eAAe;EAC9B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY,EAAE,qBAAqB;EACnC,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".salary-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n.error-message-for-uploadfile {\n  white-space: pre-wrap;\n  max-height: 150px;\n  overflow-y: auto;\n  color: red;\n  font-size: 14px;\n}\n.upload-box-payslip {\n  width: 250px;  /* Set width */\n  height: 50px;  /* Set height */\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  cursor: pointer;\n  margin-right:630px;\n  margin-top:20px;\n}\n\n\n.file-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  cursor: pointer;\n}\n\n.upload-text {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  color: #333;\n  text-align: left;\n}\n\n.upload-title {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.file-name {\n  font-size: 12px;\n  color: #777;\n  margin-top: 4px;\n}\n\n.upload-icon {\n  width: 30px;\n  height: 30px;\n  margin-right: 20px;  /* Ensures proper spacing */\n}\n\n.error-message {\n  color: red;\n  font-size: 14px;\n  font-weight: bold;\n}\n/* Table wrapper to ensure scrollbar starts from the first column */\n.salary-table-container {\n  width: 100%; \n  max-width: 900px;\n  max-height: 500px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  background: #fff;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow: hidden; /* Prevents double scrollbars */\n  margin-top:-50px;\n}\n\n.admin-table-container{\n  width: 100%; \n  max-width: 900px;\n  max-height: 500px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  background: #fff;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  margin: 0 auto; \n  overflow-y: auto; /* Prevents double scrollbars */\n  margin-top:-30px;\n}\n\n/* New wrapper to manage scrolling */\n.table-scroll-wrapper {\n  width: 100%;\n}\n\n/* Table styling */\n.salary-table {\n  width: max-content; /* Ensures table expands based on content */\n  border-collapse: collapse;\n  min-width: 800px; \n  table-layout: auto;\n\n  border-collapse: collapse; /* FIX: Prevents overlap issues */\n  border-spacing: 0; /* Ensures no gaps */\n}\n.salary-table-wrapper {\n  max-height: 400px;  /* or any height you prefer */\n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #ccc;\n}\n\n/* Header and cell styling */\n.salary-table th {\n  min-width: 120px; /* Ensure each column is at least 120px wide */\n  text-align: left;\n  height:40px;\n  font-weight: bold;\n  background-color: #c0bebe;\n  border-color:#f8f9fa\n  \n}\n.salary-table thead {\n  position: sticky;\n  top: 0;\n  padding: 10px;\n\n  background-color: #f8f9fa; /* Light background for visibility */\n  z-index: 2;\n}\n.salary-table td {\n  border: 1px solid #ddd;\n  padding: 10px;\n  text-align: left;\n  white-space: nowrap; /* Prevent text wrapping */\n}\n.salary-table tfoot {\n  position: sticky;\n  bottom: 0;\n  background: #ddd; /* Light grey background for footer */\n  font-weight: bold;\n  z-index: 2;\n}\n/* Sticky Header (top row) */\n.salary-table thead th {\n  position: sticky;\n  top: 0;\n  background: #c0bebe;\n  z-index: 10; /* High enough to stay above content */\n}\n\n\n.salary-table tfoot {\n  position: sticky;\n  bottom: 0;\n  background-color: #fff; /* Match table background */\n  z-index: 2;\n}\n.invalid-cell {\n  background-color: #ffcccc !important;  /* Light red */\n  border: 1px solid #ff0000;\n}\n\n.updated-cell {\n  background-color: #ccffcc !important;  /* Light green */\n  border: 1px solid #00cc00;\n}\n\n.sticky-footer {\n  font-weight: bold;\n  text-align: right;\n  padding: 10px;\n  background-color: #f1f1f1; /* Light gray background */\n  border-top: 2px solid #ddd;\n}\n\n\n/* Alternate row colors */\n.salary-table tbody tr:nth-child(even) {\n  background: white;\n}\n\n\n/* Sticky first column only */\n\n\n/* ✅ Row Hover Effect for Full Row */\n.salary-table tbody tr:hover {\n  background-color: #e4ebf1d0;\n}\n\n/* ✅ Ensure Sticky Columns Also Change on Hover */\n.salary-table tbody tr:hover td:first-child,\n.salary-table tbody tr:hover td:nth-child(2) {\n  background-color: #e4ebf1d0; /* Same color as row hover */\n}\n\n\n/* Alternate Row Colors */\n/* .salary-table tbody tr:nth-child(even) {\n  background-color: #f2f2f2; */\n/* Ensure table adjusts to content */\n.salary-table th {\n  text-align: left;\n  font-weight: bold;\n  \n}\n\n.salary-table th:nth-child(1),\n.salary-table th:nth-child(2) {\n  background: #c0bebe; /* Ensure consistency with header background */\n  border-right: 2px solid #ddd; /* Light blue border */\n}\n\n\n\n\n\n\n/* Upload Button */\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  left: 0; /* Ensures it sticks while scrolling horizontally */\nmargin-left:15px;\n  position: sticky;\n\n}\n\n.table-heading {\n  margin: 0;\n}\n\n.salary-search-box {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  outline: none;\n  width: 200px; /* Adjust width as needed */\n  transition: all 0.3s ease-in-out;\n}\n\n.salary-search-box:focus {\n  border-color: #007bff; /* Blue border on focus */\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);\n}\n\n\n\n\n\n\n\n.upload-btn {\n  padding: 8px 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.upload-btn:hover {\n  background-color: #0056b3;\n}\n\n\n.upload-btn:hover {\n  background-color: #0056b3;\n}\n\n\n/* Highlight updated rows */\n.updated-row {\n  background-color: #ffeb3b !important; /* Yellow highlight */\n  font-weight: bold;\n  transition: background 0.5s ease-in-out;\n}\n\n\n\n/* Search Input */\n\n/* .salary-table th {\n  background-color: #4CAF50;\n  color: white;\n  padding: 8px;\n  text-align: left;\n} */\n/* Upload Button */\n.upload-btn {\n  padding: 8px 12px;\n  font-size: 14px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.upload-btn:hover {\n  background-color: #0056b3;\n}\n\n.updated-row {\n  background-color: #ffeb3b !important; /* Yellow highlight */\n  transition: background-color 0.5s ease;\n}\n.updated-cell {\n  background-color: #ffeb3b !important; /* Yellow highlight */\n  font-weight: bold;\n  transition: background-color 0.5s ease;\n}\n\n\n.no-updates-message {\n  color: green;\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n\n\n.error-message {\n  color: red;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.invalid-cell {\n  background-color: #ffcccc !important;\n  color: red;\n  font-weight: bold;\n}\n\n\n.salary-month-year-selector-box{\n  width: 250px;  /* Set width */\n  height: 50px;  /* Set height */\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  cursor: pointer;\n  margin-left:320px;\n  margin-top:-75px;\n}\n\n.salary-month-year-selector {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top:-7%;\n}\n\n.salary-month-year-dropdown {\n  padding: 4px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 220px;\n}\n\n\n\n.error-message-for-uploadfile{\n  \n  color: red;\n  font-weight: bold;\n  margin: 5px ;\n  min-height: 20px; /* Ensures space is reserved for the error message */\n}\n.error-cell {\n  background-color: #ffcccc !important; /* Light red background */\n  border: 2px solid red !important;\n  color: red !important;\n  font-weight: bold;\n}\n.error-cell {\n  background-color: #ffcccc; /* Light red background for errors */\n  border: 2px solid red;\n}\n\n.updated-cell {\n  background-color: #ccffcc; /* Light green for updated cells */\n}\n/* Scrollable container */\n/* Scrollable container */\n.adminsalary-table-container {\n  width: 100% !important;\n  max-width: 1400px; /* Limit table width */\n  padding: 8px;\n  max-height: 200px; /* Adjust height for scrolling */\n  position: relative; /* Ensure correct positioning of sticky header */\n}\n\n/* Table Styling */\n.adminsalary-table {\n  width: 100%;\n  min-width: 600px; /* Ensure table does not shrink too much */\n  border-collapse: collapse;\n  text-align: left;\n}\n\n/* Table Header */\n.adminsalary-table th {\n  padding: 8px;\n  background: #c0bebe;\n  white-space: nowrap; /* Prevent header text from wrapping */\n  border: 1px solid #ddd;\n  z-index: 3;\n  height: 30px;\n  position: sticky;\n  top: 0;  /* Make header stick at the top of the container */\n  background-color: #c0bebe;\n}\n\n/* Table Data Cells */\n.adminsalary-table td {\n  padding: 8px;\n  white-space: nowrap; /* Prevent wrapping */\n  border: 1px solid #ddd;\n}\n\n\n/* Alternate Row Styling */\n.adminsalary-table tbody tr:nth-child(even) {\n  background: #f9f9f9;\n}\n\n/* Hover Effect */\n.adminsalary-table tbody tr:hover {\n  background: #f1f1f1;\n}\n\n\n.adminsalary-table tbody tr:hover {\n  background: #e0e0e0 !important;\n}\n\n/* Sticky Footer */\n.adminsalary-table tfoot {\n  position: sticky;\n  bottom: 0;\n  background-color: #fff;\n  z-index: 2;\n  text-align: right; /* Align the total amount to the right */\n  padding: 8px;\n  font-weight: bold;\n}\n\n.adminsalary-sticky-footer {\n  position: sticky;\n  bottom: 0;\n  background-color: #fff;\n  text-align: right;\n  font-weight: bold;\n  padding: 10px;\n  border-top: 2px solid #ccc;\n  z-index: 1;\n}\n\n.footer-cell {\n  display: inline-block;\n  padding-right: 20px;\n}\n\n\n.net-salary-row {\n  position: sticky;\n  bottom: 0;\n  background-color: #f1f1f1;\n  font-weight: bold;\n  z-index: 2;\n  height: 30px;\n  text-align: left;\n}\n\n/* Ensure footer content has a similar background as header */\n\n\n/* Make footer sticky and always visible */\n.adminsalary-sticky-footer {\n  position: sticky;\n  bottom: 0;\n  width: 100%;\n  background-color: #c0bebe;\n  color: black;\n  padding: 10px 16px;\n  font-weight: bold;\n  text-align: right;\n  border-top: 2px solid #ccc;\n  z-index: 10; /* higher than sticky first/second columns */\n  display: flex;\n  justify-content: flex-end;\n  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow */\n}\n\n.footer-cell {\n  flex: 1;\n}\n\n\n.reference-container {\n  display: flex;\n  justify-content: center; /* Centers the elements */\n  align-items: center;\n  flex-wrap: wrap; /* Prevents overlap on smaller screens */\n  gap: 20px; /* Adds spacing between elements */\n  width: 100%;\n  margin-top: 20px;\n}\n.reference-box {\n  width: 250px;  /* Set width */\n  height: 50px;  /* Set height */\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  cursor: pointer;\n  margin-left:630px;\n  margin-top:-210px;\n  position: relative;\n  z-index: 1;\n}\n\n.reference-text {\n  font-size: 14px;\n  color: #131010;\n  margin-bottom: 8px;\n}\n\n.download-template-btn {\n  background-color: #007bff;\n  color: white;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 10px;\n}\n\n.download-template-btn:hover {\n  background-color: #0056b3;\n}\n\n.adminsalary-table-header {\n  text-align: center;\n  font-size: 20px;\n  font-weight: bold;\n  padding: 10px;\n  color: black;\n}\n.admin-search-box {\n  width: 100px; /* Adjust the width */\n  padding: 6px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-left: -45%;\n  outline: none;\n}\n.admin-search-box::placeholder {\n  color: #888;\n  font-size: 12px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .table-container {\n    max-height: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
